<template>
  <div
    class="organisation-details container"
    v-if="sortedMembers"
    :class="{ updating: saveInProgress }"
  >
    <organisation-member-add-dialog ref="memberAddDialog"></organisation-member-add-dialog>
    <organisation-member-removal-dialog ref="memberRemovalDialog">
    </organisation-member-removal-dialog>
    <div class="row">
      <div class="col-sm-12">
        <div v-if="hasFilter('plans')" class="col-md-5">
          <h3>Develop</h3>
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="col-md-10">Filter by</th>
                <th scope="col" class="col-md-2">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter(null)"
                    >Develop plans started(including completed)</a
                  >
                </td>
                <td>{{ plansStarted.length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('completed')">
                    Develop plans completed</a
                  >
                </td>
                <td>{{ plansCompleted.length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('develop1')">
                    Members on Develop Week 1</a
                  >
                </td>
                <td>{{ peopleWithDevW(1).length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('develop2')">
                    Members on Develop Week 2</a
                  >
                </td>
                <td>{{ peopleWithDevW(2).length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('develop3')">
                    Members on Develop Week 3</a
                  >
                </td>
                <td>{{ peopleWithDevW(3).length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('develop4')">
                    Members on Develop Week 4</a
                  >
                </td>
                <td>{{ peopleWithDevW(4).length }}</td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:void(0)" @click="toggleFilter('develop5')">
                    Members on Develop Week 5</a
                  >
                </td>
                <td>{{ peopleWithDevW(5).length }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-12 content-column" :key="`${internalFilter || 'unfilter'}-${appliedFilter || 'unfilter'}`">
          <h3>
          </h3>
          <table
            class="table table-hover"
            v-data-table="
              {
                paging: false,
                searching: true,
                info: false,
                columnDefs: [
                  { targets: [-1, -2], orderable: false },
                  { targets: [3], orderDataType: 'dom-sort' }
                ],
                order: [[0, 'asc']],
              }
            "
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Last login</th>
                <th>Teams</th>
                <th>Solo</th>
                <th>Viewpoints</th>
                <th>Develop</th>
                <th class="col-sm-2">Team Pathways</th>
                <th class="col-sm-2">Personal Pathways</th>
                <th v-if="appliedFilter && appliedFilter === 'teq'">TEQs</th>
                <th v-else></th>
              </tr>
            </thead>
            <tbody v-if="filteredMembers.length > 0">
              <tr
                v-for="member in filteredMembers"
                :key="member.shortUserDetails.id"
                data-test="member-table-row"
              >
                <td>
                  {{ member.shortUserDetails.firstName }} {{ member.shortUserDetails.lastName }}
                </td>
                <td>
                  {{ member.shortUserDetails.lastLoggedIn }}
                </td>
                <td>
                  <div
                    v-for="team in teamsMemberOf(member)"
                    :key="team.group.id"
                    data-test="team-button"
                  >
                    <button
                      type="button"
                      class="btn btn-default btn-sm"
                      @click="openDetailsNewTab(`/myorganisation/group/details/${team.group.id}`)"
                    >
                      {{ team.group.name }}
                    </button>
                  </div>
                </td>
                <td :data-sort="member.solo?.completedDate ? getSortableDate(member.solo.completedDate) : ''">
                  <a :href="`/soloreport/view/${member.solo.id}`" v-if="member.solo">{{
                    displayDate(member.solo.completedDate)
                  }}</a>
                </td>
                <td>
                  <div v-if="member.viewpoints">
                    <a :href="`/viewpoints/view/${member.shortUserDetails.id}`"
                      >{{ member.viewpoints.length }} Respondents</a
                    >
                  </div>
                </td>
                <td>
                  <div v-if="member.development.currentStrengthProgress">
                    {{ member.development.currentStrengthProgress.strengthItemDisplayTitle }}: Day
                    {{ member.development.currentStrengthProgress.lastDayIndex }}
                    <span v-if="member.development.currentStrengthProgress.lastReadActionTime">
                      -
                      {{
                        displayDate(member.development.currentStrengthProgress.lastReadActionTime)
                      }}
                    </span>
                  </div>
                  <div v-if="hasFilter('plans')">
                    <div
                      v-for="(otherProgress, index) in member.development.otherProgress"
                      :key="index"
                    >
                      <span :style="fontweight(otherProgress.lastDayIndex)">
                        {{ otherProgress.strengthItemDisplayTitle }}: Day
                        {{ otherProgress.lastDayIndex }}
                      </span>
                      <span v-if="otherProgress.lastReadActionTime">
                        - {{ displayDate(otherProgress.lastReadActionTime) }}
                      </span>
                      <br />
                    </div>
                  </div>
                </td>
                <td class="col-sm-2" data-test="pathway-table-data">
                  <template v-if="member.pathways.currentPathwaysInProgress">
                    <p
                      v-if="member.pathways.currentPathwaysInProgress.length > 0"
                      style="text-decoration: underline; margin-bottom: 0"
                    >
                      Current progress:
                    </p>
                    <div
                      v-for="(currentPathways, index) in member.pathways.currentPathwaysInProgress"
                      :key="currentPathways.cmsStepUid + index"
                      style="display: flex; align-items: center"
                      data-test="current-pathway-data"
                    >
                      <TeamMemberPathway :model="currentPathways"></TeamMemberPathway>
                      <Tooltip
                        v-if="teamsMemberOf(member).length > 1"
                        :text="getTeamName(currentPathways, member)"
                        :enterable="false"
                        tabindex="0"
                        data-test="team-pathway-tooltip"
                      >
                        <img
                          src="../../../assets/information-icon.svg"
                          alt="team info"
                          style="width: 15px; height: 15px; display: inline; margin: 0 0 5px 5px"
                        />
                      </Tooltip>
                    </div>
                  </template>
                  <template v-if="hasFilter('pathways') && member.pathways.otherProgress">
                    <p
                      v-if="member.pathways.otherProgress.length > 0"
                      style="text-decoration: underline; margin-bottom: 0"
                    >
                      Other progress:
                    </p>
                    <div
                      v-for="(otherPathways, index) in member.pathways.otherProgress"
                      :key="otherPathways.cmsStepUid + index"
                      style="display: flex; align-items: center"
                      data-test="other-pathway-data"
                    >
                      <TeamMemberPathway :model="otherPathways"></TeamMemberPathway>
                      <Tooltip
                        v-if="teamsMemberOf(member).length > 1"
                        :text="getTeamName(otherPathways, member)"
                        :enterable="false"
                        tabindex="0"
                      >
                        <img
                          src="../../../assets/information-icon.svg"
                          alt="team info"
                          style="width: 15px; height: 15px; display: inline; margin: 0 0 5px 5px"
                        />
                      </Tooltip>
                    </div>
                  </template>
                </td>
                <td class="col-sm-2" data-test="personal-pathway-table-data">
                  <template v-if="member.personalPathways?.currentPathwaysInProgress">
                    <p
                      v-if="member.personalPathways.currentPathwaysInProgress.length > 0"
                      style="text-decoration: underline; margin-bottom: 0"
                    >
                      Current progress:
                    </p>
                    <div
                      v-for="(currentPathways, index) in member.personalPathways.currentPathwaysInProgress"
                      :key="currentPathways.cmsStepUid + index"
                      style="display: flex; align-items: center; margin-bottom: 1rem"
                      data-test="current-personal-pathway-data"
                    >
                      <PersonalMemberPathway
                        :model="currentPathways"
                      ></PersonalMemberPathway>
                    </div>
                  </template>
                  <template v-if="hasFilter('pathways') && member.personalPathways?.otherProgress">
                    <p
                      v-if="member.personalPathways.otherProgress.length > 0"
                      style="text-decoration: underline; margin-bottom: 0"
                    >
                      Other progress:
                    </p>
                    <div
                      v-for="(otherPathways, index) in member.personalPathways.otherProgress"
                      :key="otherPathways.cmsStepUid + index"
                      style="display: flex; align-items: center; margin-bottom: 1rem"
                      data-test="other-personal-pathway-data"
                    >
                      <PersonalMemberPathway
                        :model="otherPathways"
                        :isCurrentPathway="false"
                      ></PersonalMemberPathway>
                    </div>
                  </template>
                </td>
                <td v-if="hasFilter('teq')">
                  <div v-for="teq in member.teqsCompleted" :key="teq.team.id">
                    <button
                      type="button"
                      class="btn btn-default btn-sm"
                      @click="openDetailsNewTab(`/team/effectiveness/${teq.team.id}`)"
                    >
                      {{ teq.team.name }} - TEQ
                    </button>
                  </div>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import axios from "axios";
import moment from "dayjs";
import { Tooltip } from "uiv";
import OrganisationMemberAddDialog from "./organisation-member-add-dialog.vue";
import OrganisationMemberRemovalDialog from "./organisation-member-removal-dialog.vue";
import TeamMemberPathway from "../../group-member-table/team-member-pathway.vue";
import PersonalMemberPathway from "../../group-member-table/personal-member-pathway.vue";
import type {
  DevelopStrengthProgressApiModel,
  GroupAndMembersApiModel,
  OrganisationAndMembersApiModel,
  OrganisationMemberApiModel,
  TeamMemberCompletedPathwayStepApiModel,
} from "../../../api-models";

const props = defineProps<{
  model: OrganisationAndMembersApiModel;
  sortedMembers: OrganisationMemberApiModel[];
  appliedFilter: string | null;
}>();

const emit = defineEmits(["revalidate-org-data"]);

// template refs
const memberAddDialog = ref<InstanceType<typeof OrganisationMemberAddDialog> | null>(null);
const memberRemovalDialog = ref<InstanceType<typeof OrganisationMemberRemovalDialog> | null>(null);

const LAST_DAY = 25;

const saveInProgress = ref(false);
const internalFilter = ref<string | null>(null);

function valueExists(str: string | null | undefined): boolean {
  return str !== null && str !== undefined;
}

const plansStarted = computed((): DevelopStrengthProgressApiModel[] => {
  const allPlans: DevelopStrengthProgressApiModel[] = [];
  props.model?.members.forEach((x) => {
    const str = x.development?.currentStrengthProgress?.strengthItemId;
    if (valueExists(str)) {
      allPlans.push(x.development.currentStrengthProgress);
    }
    x.development?.otherProgress?.forEach((strength) => {
      if (valueExists(strength.strengthItemId)) {
        allPlans.push(strength);
      }
    });
  });
  return allPlans;
});

const plansCompleted = computed((): DevelopStrengthProgressApiModel[] => {
  return plansStarted.value.filter((plan) => plan.lastDayIndex === LAST_DAY);
});

const membersWithCompletedPlans = computed((): OrganisationMemberApiModel[] => {
  return props.sortedMembers.filter(
    (member) =>
      member.development.currentStrengthProgress.lastDayIndex === LAST_DAY ||
      member.development.otherProgress.some((p) => p.lastDayIndex === LAST_DAY),
  );
});

function peopleWithDevW(week: number): OrganisationMemberApiModel[] {
  return (
    props.model.members.filter(
      (x) =>
        x.development.currentStrengthProgress &&
        x.development.currentStrengthProgress.lastDayIndex > (week - 1) * 5 &&
        x.development.currentStrengthProgress.lastDayIndex <= week * 5,
    ) ?? []
  );
}

const filteredMembers = computed((): OrganisationMemberApiModel[] => {
  if (!internalFilter.value) return props.sortedMembers ?? [];
  if (internalFilter.value === "completed") return membersWithCompletedPlans.value;
  const week = parseInt(internalFilter.value.replace("develop", ""), 10);
  return peopleWithDevW(week);
});

function teamsMemberOf(member: OrganisationMemberApiModel): GroupAndMembersApiModel[] {
  return (
    props.model?.teams.filter((x) => x.members.find((m) => m.id === member.shortUserDetails.id)) ??
    []
  );
}

function getTeamName(
  pathway: TeamMemberCompletedPathwayStepApiModel,
  member: OrganisationMemberApiModel,
): string {
  const { teamId } = pathway;
  const relevantTeam = teamsMemberOf(member).find((team) => {
    return team.group.id === teamId;
  });
  return relevantTeam?.group.name ?? "";
}

function displayDate(dateString?: string): string {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
}

function getSortableDate(dateString?: string): string {
  return dateString ? moment(dateString).toISOString() : "";
}

function fontweight(lastDay: number): string {
  return lastDay === LAST_DAY ? "font-weight:bold" : "font-weight:normal";
}

function hasFilter(filter: string): boolean | undefined {
  return props.appliedFilter?.startsWith(filter) || false;
}

function addMembers(): void {
  memberAddDialog.value?.open(props.model).finally(() => {
    memberAddDialog.value?.close();
  });
}

function toggleFilter(filter: string | null): void {
  internalFilter.value = internalFilter.value === filter ? null : filter;
}

function openDetailsNewTab(href: string): void {
  const newTab = window.open(href, "_blank");
  if (newTab) {
    newTab.opener = null;
  }
}
</script>

<style scoped lang="less">
@import (reference) "../../../styles/bootstrap/variables.less";

.organisation-details.updating {
  opacity: 0.5;
  cursor: wait;

  & > * {
    user-select: none;
    pointer-events: none;
  }
}

.tab-pane table td {
  line-height: 2;
}

.role-admin {
  font-weight: bold;
  color: @brand-primary;
}

.dropdown-menu {
  // Position to the left to ensure visibility on mobile
  right: 0;
  left: unset;
}

.subs-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 0.75rem;

    &:hover {
      background-color: #f8f8f8;
      cursor: pointer;
    }
  }
}

.active {
  background-color: #f8f8f8;
  font-weight: bold;
}

.subs-list-checkbox {
  margin: 2rem 0;

  label {
    margin-right: 1rem;
  }

  input {
    accent-color: @brand-primary;
    cursor: pointer;
  }
}
</style>
